import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { toast } from '../../hooks/use-toast';
import { api } from '../api';
import { errorMessage } from '../errors';
import PickSelect from '../shared/PickSelect';
import { ROLE_LABELS, INVITABLE_ROLES } from './roles';

// Ticket 202: change a member's seat role via PATCH /admin/users/{id}. The
// server owns the guards (last owner, owner seats, single owner), so a refusal
// is shown as the server worded it.
export default function ChangeRoleDialog({ member, onClose, onSaved }) {
  const [role, setRole] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { setRole(member?.membership_role || ''); }, [member]);

  const name = member?.name || member?.email;
  const unchanged = !member || role === member.membership_role;
  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/admin/users/${member.user_id}`, { role });
      toast({ title: 'Role changed', description: `${name} is now ${ROLE_LABELS[role] || role}.` });
      onSaved();
    } catch (e) {
      toast({ title: 'Could not change role', description: errorMessage(e) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!member} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle style={{ color: '#070B5F' }} className="font-serif">Change role for {name}</DialogTitle>
          <DialogDescription>Their access follows the new role right away. This is audited.</DialogDescription>
        </DialogHeader>
        <PickSelect label="Role" value={role} onChange={setRole} testId="org-role-select"
          options={INVITABLE_ROLES.map((r) => ({ value: r, label: ROLE_LABELS[r] }))} />
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={save} disabled={busy || unchanged} className="btn-gold" data-testid="org-role-save">Change role</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
